<template>
  <div>
    <div style="width: fit-content">
      <div class="section">
        <el-form :disabled="readonly" :inline="true" label-position="left" label-width="75px">
          <el-form-item :label="$t('SeaExport.BusinessNo')">
            <!-- <el-input v-model="job.jobNo" :disabled="true" class="job-no-color" /> -->
            <el-input v-model="job.jobNo" :disabled="true" no="jobNo" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MasterBillNo')">
            <el-tooltip :content="(job.express||mblCodeNumValidate)?'':$t('queryJob.TheDoesNotComplyRules')" placement="right-end">
              <div style="display: flex;">
                <el-checkbox v-model="job.express" no="express" style="margin-right: 10px;">{{ $t('SeaExport.ExpressInfo') }}</el-checkbox>
                <cargo-input
                  v-show="job.express"
                  v-model="job.mbl"
                  no="mbl"
                  :maxlength="32"
                  :input-convert="filterNonDigit"
                  style="width: 170px;margin-right: 20px;"
                />
                <cargo-input
                  v-show="!job.express"
                  :value="mblCode"
                  no="mblCode"
                  :maxlength="3"
                  :input-convert="filterNonDigit"
                  :class="mblCodeNumValidate?'':'red'"
                  style="width: 60px;margin-left: 2px;"
                  @input="onMblCodeInput"
                  @blur="onMblCodeNumBlur"
                />
                <span v-show="!job.express" style="padding-right: 2.5px;padding-left: 2.5px;">-</span>
                <cargo-input
                  v-show="!job.express"
                  ref="mblNum"
                  v-model="mblNum"
                  no="mblNum"
                  :maxlength="8"
                  :input-convert="filterNonDigit"
                  :class="mblCodeNumValidate?'':'red'"
                  style="width: 108px;margin-right: 20px;"
                  @blur="onMblCodeNumBlur"
                />
              </div>
            </el-tooltip>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.SoNo')">
            <so-no-input v-model="job.jobSoNo" :disabled="readonly" no="jobSoNo" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CustomerReferenceNumber')">
            <cargo-input v-model="job.customerRefNo" no="customerRefNo" :auto-uppercase="true" :trim="true" />
          </el-form-item>
          <el-checkbox v-model="job.usCustomsClearance" no="usCustomsClearance">{{ $t('queryJob.UsCustomsClearance') }}</el-checkbox>
          <el-checkbox v-model="job.insure" no="isInsure" style="margin-left: -20px;">{{ $t('SeaExport.InsureInfo') }} </el-checkbox>
          <span
            id="toInsure"
            v-permission="['button_insurance_toInsure']"
            type="primary"
            :class="!isEdit?'el-button el-button--primary el-button--mini':'el-button el-button--primary el-button--mini is-disabled'"
            style="min-width:50px!important;margin-left:15px"
            @click="()=>{if (!isEdit){toInsure()}}"
          >{{ $t('SeaExport.Insure') }}
          </span>
        </el-form>
      </div>
      <div style="display: flex">
        <el-form label-position="right" label-width="120px" style="display: flex;">
          <div class="section form-column">
            <template v-if="isZY">
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.AllowSaleProduct') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.basic_data_AllowSaleProduct"
                  :disabled="readonly"
                  filterable
                  no="allowSaleProduct"
                  clearable
                  :data-filter-function="p => p.statusEnabled && p.airImportEnabled"
                  :default-value="job.saleProductCode || ''"
                  @parentCallBack="p => {job.saleProductCode = p.value}"
                />
              </el-form-item>
              <el-form-item>
                <span slot="label" class="blue">{{ $t('SeaExport.FullOrInside') }}</span>
                <cargo-advance-select
                  :select-type="selectTypeNames.local_cache_FullOrInside$FULL_OR_INSIDE"
                  :disabled="readonly"
                  no="fullOrInside"
                  clearable
                  :default-value="job.fullOrInside || ''"
                  @parentCallBack="p => {job.fullOrInside = p.value}"
                />
              </el-form-item>
            </template>
            <el-form-item :label="$t('SeaExport.SolicitationType')">
              <cargo-advance-select
                no="cargoSource"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.local_cache_CargoSource"
                callback-method-type="value"
                :default-value="job.cargoSource"
                :callback-params="{key:'cargoSource'}"
                :clearable="false"
                placeholder=" "
                @parentCallBack="cargoSource_Change"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomJobType')">
              <cargo-advance-select
                no="customJobType"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                :method-params="{type:job.lob}"
                :default-value="job.customJobType"
                :static-options="customJobTypeList"
                @parentCallBack="p=>{job.customJobType=p.value;onCustomJobTypeChange(p)}"
              />
            </el-form-item>
            <el-form-item v-if="job.customJobType && secondaryCustomJobTypeList.length > 0" :label="$t('CargoMsg.Cargo_Grade')">
              <cargo-advance-select
                ref="secondaryCustomJobType"
                no="secondaryCustomJobType"
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CutomJobType"
                filterable
                :cache="false"
                :default-value="job.secondaryCustomJobType"
                :tag-name="isZh?'name':'englishName'"
                :static-options="secondaryCustomJobTypeList"
                @parentCallBack="p=>{job.secondaryCustomJobType=p.value}"
              />
            </el-form-item>
            <el-form-item v-show="job.cargoSource==='NC'">
              <span slot="label" class="blue">{{ $t('SeaExport.NominatedAgent') }}</span>
              <cargo-advance-select
                no="designationAgent"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{overseaAgent:true,active:true}"
                :default-value="job.designationAgent ||''"
                tag-name="englishName"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="designationAgentChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OrderChannels')">
              <el-input v-model="job.salesChannel" :disabled="true" no="salesChannel" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ConsignationRelationNumber')">
              <el-input no="trustFromJob" :value="job.trustFromJob" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BusinessCommissionedRelationNumber')">
              <el-input no="relatedJob" :value="job.relatedJob" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PortOfLoadingAgent')">
              <cargo-advance-select
                no="loadingAgentId"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{overseaAgent:true,active:true}"
                :callback-params="{key:'loadingAgentId'}"
                callback-method-type="value"
                tag-name="englishName"
                :default-value="job.loadingAgentId ||''"
                placeholder=" "
                @parentCallBack="p=>{
                  setJobSelectNum(p)
                  OverseaCustomerUtils.destinationAgentChangeHandler(view)
                }"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineCompany')">
              <cargo-advance-select
                no="carrierId"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{airCmp:true,active:true}"
                :default-value="job.carrierId ||''"
                placeholder=" "
                @parentCallBack="txtCarrierId_changeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Flight')">
              <cargo-input v-model="job.voyageFlight" :disabled="readonly" no="voyageFlight" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item v-if="bookingAgentVisible" :label="$t('SeaExport.BookingAgent')">
              <cargo-advance-select
                no="bookingAgent"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true,active:true}"
                :callback-params="{key:'bookingAgent'}"
                callback-method-type="value"
                :default-value="job.bookingAgent ||''"
                placeholder=" "
                @parentCallBack="obj=>{setJobSelectNum(obj);job.groundAgentId=job.bookingAgent}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillExchangeAgent')">
              <cargo-advance-select
                no="exChangeAgent"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true,active:true}"
                :callback-params="{key:'exChangeAgent'}"
                callback-method-type="value"
                :default-value="job.exChangeAgent ||''"
                placeholder=" "
                @parentCallBack="obj=>{setJobSelectNum(obj)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PlaceOfReceipt')">
              <cargo-input v-model="job.dispatchingPlace" :disabled="readonly" no="dispatchingPlace" :auto-uppercase="true" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.LoadingPort') }}</span>
              <cargo-advance-select
                no="loadingPortCode"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Airport"
                :callback-params="{key:'loadingPortCode'}"
                callback-method-type="value"
                :default-value="valueMatch.loadingPortCode?job.loadingPortCode:''"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="obj=>{valueMatch.loadingPortCode=true;loadingPortCodeChange(obj)}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.PortOfDestination') }}</span>
              <cargo-advance-select
                no="dischargingPortCode"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Airport"
                :default-value="valueMatch.dischargingPortCode?job.dischargingPortCode:''"
                :placeholder="$t('SeaExport.RequiredItem')"
                @parentCallBack="dischargingPortCode_Change"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.FinalPlaceOfDelivery') }}</span>
              <cargo-input v-model="job.destinationPlace" :disabled="readonly" no="destinationPlace" :auto-uppercase="true" :placeholder="$t('SeaExport.RequiredItem')" />
            </el-form-item>
            <!--航线-->
            <el-form-item :label="$t('SeaExport.Airline')">
              <el-input v-model="job.regionName" no="airline" :disabled="true" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OperationDate')">
              <el-date-picker v-model="job.customsDate" :disabled="readonly" no="customsDate" type="date" value-format="yyyy-MM-dd" clearable style="width: 100%" />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.DateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  ref="etd"
                  v-model="job.etd"
                  :disabled="readonly"
                  no="etd"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  clearable
                  placeholder=""
                  style="flex: 1; width:170px; margin-right: 5px"
                  @input="etdChange"
                  @blur="()=> { handleBlur('etd', etdChange, false, false, job) }"
                />
                <span>{{ job.sailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('SeaExport.DateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  ref="eta"
                  v-model="job.eta"
                  :disabled="readonly"
                  no="eta"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  clearable
                  :placeholder="$t('SeaExport.RequiredItem')"
                  style="flex: 1; width:170px; margin-right: 5px"
                  @input="etaChange"
                  @blur="()=> { handleBlur('eta', etaChange, false, false, job) }"
                />
                <span>{{ job.etaSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.ActualDateOfDeparture2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  ref="atd"
                  v-model="job.atd"
                  :disabled="readonly"
                  no="atd"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  clearable
                  style="flex: 1; width:170px; margin-right: 5px"
                  @input="atdChange"
                  @blur="()=> { handleBlur('atd', atdChange, false, false, job) }"
                />
                <span>{{ job.atdSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.ActualDateOfArrival2') }}</span>
              <div style="display: flex">
                <el-date-picker
                  ref="ata"
                  v-model="job.ata"
                  :disabled="readonly"
                  no="ata"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  value-format="yyyy-MM-dd HH:mm"
                  clearable
                  style="flex: 1; width:170px; margin-right: 5px"
                  @input="ataChange"
                  @blur="()=> { handleBlur('ata', ataChange, false, false, job) }"
                />
                <span>{{ job.ataSailingDay|filterWeek }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CategoryOfGoods')">
              <cargo-advance-select
                no="cargoCode"
                :select-type="selectTypeNames.basic_data_CargoInformation"
                :disabled="readonly"
                filterable
                :callback-params="{key:'cargoCode'}"
                :default-value="job.cargoCode"
                placeholder=" "
                @parentCallBack="txtCargoInformationChangeHandler"
              />
            </el-form-item>
            <el-form-item>
              <cargo-input v-model="job.cargoName" :disabled="readonly || !job.cargoCode" no="cargoName" />
            </el-form-item>
            <el-form-item :label="$t('Message.TerminalAddress')">
              <cargo-rich-textarea
                v-model="job.deliveryAddress"
                no="deliveryAddress"
                :disabled="readonly"
                style="height: 110px;"
                @dblclick.native="showAdvanceTextDialog($t('Message.TerminalAddress'),job.deliveryAddress, undefined,val=>{job.deliveryAddress=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_TransportSource')">
              <cargo-advance-select
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_TransportSource"
                no="transportSource"
                :default-value="job.transportSource"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>job.transportSource=item.value"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_ServiceStatisticalArea')">
              <cargo-advance-select
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_StatisticArea"
                no="statisticArea"
                :default-value="job.statisticArea"
                :cache="false"
                tag-value="code"
                placeholder=" "
                @parentCallBack="item=>job.statisticArea=item.value"
              />
            </el-form-item>
          </div>
          <div class="section form-column" :style="$selectByLang('', 'width: 350px')">
            <el-form-item :label="$t('SeaExport.DateOfDelivery')">
              <el-date-picker v-model="job.deliverDate" :disabled="readonly" no="deliverDate" type="date" value-format="yyyy-MM-dd" clearable style="width: 100%" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.DateOfArrivalTheWarehouse')">
              <el-date-picker v-model="job.arriveStorageDate" :disabled="readonly" no="arriveStorageDate" type="date" value-format="yyyy-MM-dd" clearable style="width: 100%" />
            </el-form-item>
            <el-form-item label>
              <div style="display: flex;justify-content: flex-end">
                <el-button type="primary" no="CopyFromOtherBill" :disabled="readonly" @click="importPromptTitleDialog.visible=true">{{ $t('SeaExport.CopyFromOtherBill') }}</el-button>
                <el-button type="primary" no="CodeSearching" :disabled="readonly" @click="billAddressDialog.visible=true">{{ $t('SeaExport.CodeSearching') }}</el-button>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Shipper')">
              <div style="display: flex;justify-content: space-between;margin-bottom: 10px">
                <cargo-input v-model="job.shipperCode" :disabled="readonly" no="shipperCode" :auto-uppercase="notUppercaseShipperConsigneNotify" :placeholder="$t('Tool.Code')" style="width:90px;margin-right: 5px" />
                <cargo-advance-select
                  no="shipperId"
                  filterable
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{shipper:true,active:true}"
                  :default-value="job.shipperId||''"
                  tag-name="englishName"
                  style="flex: 1"
                  placeholder=" "
                  @parentCallBack="shipperAutoCompleteChange"
                />
              </div>
              <cargo-input
                v-model="job.shipperLine1"
                :disabled="readonly"
                no="shipperLine1"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Shipper'),mergeShipperLine(),undefined,splitShipperLine)"
              />
              <char-count inline :form="job" prefix="shipper" style="float:right" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Consignee')">
              <div style="display: flex;justify-content: space-between;margin-bottom: 10px">
                <cargo-input v-model="job.consigneeCode" :disabled="readonly" no="consigneeCode" :auto-uppercase="notUppercaseShipperConsigneNotify" :placeholder="$t('Tool.Code')" style="width:90px;margin-right: 5px" />
                <cargo-advance-select
                  no="consigneeId"
                  filterable
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{consignee:true}"
                  :default-value="job.consigneeId||''"
                  tag-name="englishName"
                  style="flex: 1"
                  placeholder=" "
                  @parentCallBack="consigneeAutoCompleteChange"
                />
              </div>
              <cargo-input
                v-model="job.consigneeLine1"
                :disabled="readonly"
                no="consigneeLine1"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Consignee'),mergeConsigneeLine(),undefined,splitConsigneeLine)"
              />
              <char-count inline :form="job" prefix="consignee" style="float:right" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.NotifyParty')">
              <div style="display: flex;justify-content: space-between;margin-bottom: 10px">
                <cargo-input v-model="job.notifyCode" :disabled="readonly" no="notifyCode" :auto-uppercase="notUppercaseShipperConsigneNotify" :placeholder="$t('Tool.Code')" style="width:90px;margin-right: 5px" />
                <cargo-advance-select
                  no="notifyId"
                  filterable
                  :disabled="readonly"
                  :select-type="selectTypeNames.basic_data_Company"
                  :method-params="{notify:true}"
                  :default-value="job.notifyId||''"
                  tag-name="englishName"
                  style="flex: 1"
                  placeholder=" "
                  @parentCallBack="notifyAutoCompleteChange"
                />
              </div>
              <cargo-input
                v-model="job.notifyLine1"
                :disabled="readonly"
                no="notifyLine1"
                :auto-uppercase="notUppercaseShipperConsigneNotify"
                :use-read-only="true"
                :placeholder="readonly ? '': $t('queryJob.DoubleOfLadingHeaderUp')"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.NotifyParty'),mergeNotifyLine(),undefined,splitNotifyLine)"
              />
              <char-count inline :form="job" prefix="notify" style="float:right" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ActualQuantity')">
              <auto-number-input
                v-model="job.quantityActual"
                :disabled="readonly"
                no="quantityContract"
                :precision="0"
                :min="0"
                @change="quantityContractChange"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Package')">
              <!-- <cargo-advance-select
                filterable
                :select-type="selectTypeNames.basic_data_Packing"
                :method-params="{}"
                callback-method-type="value"
                :default-value="job.packing+''"
                tag-name="chineseName"
                :callback-params="{key:'packing'}"
                @parentCallBack="setJobSelectValue"
              /> -->
              <cargo-packing-select
                no="packing"
                :disabled="readonly"
                :default-value="job.packing"
                placeholder=" "
                @change="p => {p.key = 'packing';setJobSelectValue(p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ActualWeight')">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.weightActual"
                  :disabled="readonly"
                  no="weightContract"
                  :precision="3"
                  :min="0"
                  @change="weightContractChange"
                />
                <div style="font-size: 12px;font-weight: normal;color: #404144">
                  <span>KGS</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ActualVolume')">
              <div style="display: flex">
                <auto-number-input
                  v-model="job.cubageActual"
                  :disabled="readonly"
                  no="cubageContract"
                  :precision="3"
                  :min="0"
                  @change="cubageContractChange"
                />
                <div style="font-size: 12px;font-weight: normal;color: #404144">
                  <span>CBM</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChargedWeight')">
              <auto-number-input
                v-model="job.chargeWeight"
                :disabled="readonly"
                no="chargeWeight"
                :precision="3"
                :min="0"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.ChineseDescriptionOfGoods')">
              <cargo-input
                v-model="job.cargoChineseName"
                :disabled="readonly"
                no="cargoChineseName"
                type="textarea"
                :rows="3"
                :auto-uppercase="true"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.ChineseDescriptionOfGoods'),job.cargoChineseName,0,val=>{job.cargoChineseName=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.EnglishDescriptionOfGoods')">
              <div style="position:relative">
                <cargo-input
                  v-model="job.cargoEnglishName"
                  :disabled="readonly"
                  no="cargoEnglishName"
                  type="textarea"
                  :rows="3"
                  :auto-uppercase="isUppercaseByConfig"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.EnglishDescriptionOfGoods'),job.cargoEnglishName,0,val=>{job.cargoEnglishName=val},isUppercaseByConfig)"
                />
                <char-count :value="job.cargoEnglishName" />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Marks')">
              <div style="position:relative">
                <cargo-input
                  v-model="job.mark"
                  :disabled="readonly"
                  no="mark"
                  type="textarea"
                  :rows="3"
                  :auto-uppercase="isUppercaseByConfig"
                  @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),job.mark,0,val=>{job.mark=val},isUppercaseByConfig)"
                />
                <char-count :value="job.mark" />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PreCollection')">
              <div style="display: flex;justify-content: space-between">
                <el-input-number v-model="job.depositReceived" :disabled="readonly" no="depositReceived" style="flex-grow: 1" :controls="false" :precision="3" />
                <span>{{ localCurrency }}</span>
              </div>
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Remarks')">
              <cargo-input
                v-model="job.remarks"
                :disabled="readonly"
                no="remarks"
                type="textarea"
                :rows="3"
                :auto-uppercase="true"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.Remarks'),job.remarks,0,val=>{job.remarks=val})"
              />
            </el-form-item>
          </div>
          <div class="section form-column">
            <el-form-item :label="$t('SeaExport.ItemNo')" :class="poNoRed?'poNoClass':''">
              <cargo-input v-if="!openProjectConfig" v-model="job.poNo" :disabled="readonly" no="poNo" :auto-uppercase="true" />
              <cargo-project-select
                v-if="openProjectConfig"
                :disabled="readonly"
                no="poNo"
                :default-value="job.poNo"
                :customer-id="job.customerId"
                @change="changeProject"
              />
            </el-form-item>
            <el-form-item
              v-if="openProjectConfig"
              :label="$t('SeaExport.ProjectName')"
            >
              <el-input v-model="job.projectName" :disabled="true" no="projectName" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TransportationClause')">
              <cargo-advance-select
                no="freightTerm"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_ShippingTerm"
                callback-method-type="value"
                :default-value="job.freightTerm"
                :callback-params="{key:'freightTerm'}"
                :clearable="false"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CargoType')">
              <cargo-advance-select
                no="cargoType"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_CargoType"
                :method-params="{air:true}"
                callback-method-type="value"
                :default-value="job.cargoType"
                :callback-params="{key:'cargoType'}"
                :clearable="false"
                @parentCallBack="onCargoTypeChagne"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.MasterBLFreightTerm')">
              <cargo-advance-select
                no="paymentTermMBL"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_PaymentTerm"
                callback-method-type="value"
                :default-value="job.paymentTermMBL"
                :callback-params="{key:'paymentTermMBL'}"
                :clearable="false"
                placeholder=" "
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeTerms2')">
              <cargo-advance-select
                no="incoTerm"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_IncoTerm"
                callback-method-type="value"
                :default-value="job.incoTerm"
                :callback-params="{key:'incoTerm'}"
                :clearable="false"
                placeholder=" "
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TradeMethod')">
              <cargo-advance-select
                no="tradeTerm"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_TradeTerm"
                callback-method-type="value"
                :default-value="job.tradeTerm"
                :callback-params="{key:'tradeTerm'}"
                :clearable="false"
                @parentCallBack="setJobSelectValue"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.BillExchangeDate')">
              <el-date-picker v-model="job.transDate" :disabled="readonly" no="transDate" type="date" value-format="yyyy-MM-dd" clearable style="width: 100%" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirportHandlingAgent')">
              <cargo-advance-select
                no="groundAgentId"
                filterable
                :disabled="readonly"
                :select-type="selectTypeNames.basic_data_Company"
                :method-params="{bookingAgent:true,active:true}"
                :callback-params="{key:'groundAgentId'}"
                callback-method-type="value"
                :default-value="job.groundAgentId||''"
                placeholder=" "
                @parentCallBack="setJobSelectNum"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesCompany')">
              <el-input v-model="txtSalesOffice" :disabled="true" no="txtSalesOffice" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Sales')">
              <cargo-user-select
                ref="sales"
                :disabled="readonly || isWithinCloseAccountDate"
                no="sales"
                :method-params="{officeId:salesOfficeCheck?$store.getters.currentOfficeId:'',category:'role',shape:'sales'}"
                :default-value="job.sales||''"
                placeholder=" "
                @change="salesChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesOfGoods')">
              <cargo-user-select
                no="cargoSalesId"
                :disabled="readonly"
                :method-params="{category:'role',shape:'salesOfGoods'}"
                :default-value="job.cargoSalesId||''"
                placeholder=" "
                @change="cargoSalesChargeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.SalesDepartment')">
              <cargo-department-new-select
                :disabled="readonly || !job.sales"
                no="salesOffice"
                :sales-id="Number(job.sales)"
                :enables="true"
                :office-id="job.salesOffice"
                :department-id="Number(job.salesDepartment)"
                @change="departmentChangeHandler"
              />
            </el-form-item>

            <el-form-item :label="$t('SeaExport.OperationCompany')">
              <cargo-advance-select
                no="opOffice"
                :disabled="readonly || opOfficeDisabled"
                :select-type="selectTypeNames.basic_data_Office"
                filterable
                :callback-params="{key:'opOffice'}"
                :static-options="cacheOffices"
                callback-method-type="value"
                :default-value="job.opOffice||''"
                placeholder=" "
                @parentCallBack="p=>{job.opOffice=p.value;job.opDepartment=0;opOfficeChargeHandler()}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label" class="blue">{{ $t('CargoMsg.Cargo_OperationDepartment') }}</span>
              <cargo-department-select
                :disabled="readonly || isWithinCloseAccountDate"
                no="opDepartment"
                :enables="true"
                :office-id="Number(job.opOffice)"
                :department-id="Number(job.opDepartment)"
                placeholder=" "
                @change="p=>{job.opDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.CustomerService')">
              <cargo-user-select
                no="csr"
                :disabled="readonly"
                :method-params="{category:'role',shape:'csr'}"
                :default-value="job.csr||''"
                placeholder=" "
                :static-options="userPortRoleData.csr"
                @change="csrChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Operation')">
              <cargo-user-select :disabled="readonly" no="op" :method-params="{category:'role',shape:'op',officeId:$store.getters.currentOffice.code==='HB'?'':$store.getters.currentOfficeId}" :default-value="job.op||''" placeholder=" " :static-options="userPortRoleData.op" @change="opChangeHandler" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.Documents')">
              <cargo-user-select :disabled="readonly" no="dc" :method-params="{category:'role',shape:'doc'}" :default-value="job.dc||''" placeholder=" " :static-options="userPortRoleData.doc" @change="dcChangeHandler" />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.AirlineOffice')">
              <cargo-office-select
                no="plannerOffice"
                :disabled="true"
                :office-id="Number(job.plannerOffice)"
                @change="p=>{job.plannerOffice=p.value;job.plannerDepartment=0}"
              />
            </el-form-item>
            <el-form-item>
              <span slot="label">{{ $t('SeaExport.AirlineDepartment') }}</span>
              <cargo-department-select
                no="plannerDepartment"
                :disabled="readonly"
                :office-id="Number(job.plannerOffice)"
                :enables="true"
                :department-id="Number(job.plannerDepartment)"
                @change="p=>{job.plannerDepartment=p.value}"
              />
            </el-form-item>
            <el-form-item :label="$t('CargoMsg.Cargo_AirlinePerson')">
              <cargo-user-select
                no="planner"
                :disabled="readonly"
                :method-params="{category:'role',shape:'airline'}"
                :default-value="job.planner||''"
                placeholder=" "
                :static-options="userPortRoleData.airline"
                @change="plannerChangeHandler"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PolOperation')">
              <cargo-user-select
                no="loadingPortOp"
                :disabled="readonly"
                :method-params="{category:'role',shape:'aiop'}"
                :default-value="job.loadingPortOp||''"
                placeholder=" "
                @change="p=>{job.loadingPortOp=p.value||0}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.PodOperation')">
              <cargo-user-select
                no="destinationPortOp"
                :disabled="readonly"
                :method-params="{category:'role',shape:'aiop'}"
                :default-value="job.destinationPortOp||''"
                placeholder=" "
                @change="p=>{job.destinationPortOp=p.value||0}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.FieldOperation')">
              <cargo-user-select
                :disabled="readonly"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'siteOp'}"
                :default-value="job.siteOP||''"
                placeholder=" "
                :static-options="userPortRoleData.siteOp"
                @change="p=>{JobUtils.siteOpChangeHandler(job, p)}"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.OverseaCustomerService')">
              <cargo-user-select
                ref="overseaOp"
                no="overseaOp"
                class="input2"
                :disabled="readonly"
                :default-value="job.overseaOp||''"
                :static-options="userPortRoleData.overseaOp || overseaAgentUsersList"
                :merge-load="true"
                @change="p=>{
                  job.overseaOp = p.value
                  OverseaCustomerUtils.overseaOpChangeHandler(view, p)
                }"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole1')">
              <cargo-user-select
                ref="userDefinedRoleId1"
                no="userDefinedRoleId1"
                :disabled="readonly"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole1'}"
                :default-value="job.userDefinedRoleId1||''"
                :merge-load="true"
                placeholder=" "
                @change="p=>{userDefinedRoleId1Handler(p)}"
              />
            </el-form-item>
            <el-form-item v-show="isAddUserDefinedRoles" :label="$t('CargoMsg.Cargo_userDefinedRole2')">
              <cargo-user-select
                ref="userDefinedRoleId2"
                no="userDefinedRoleId2"
                :disabled="readonly"
                :method-params="{officeId:$store.getters.currentOfficeId,category:'role',shape:'userDefinedRole2'}"
                :default-value="job.userDefinedRoleId2||''"
                :merge-load="true"
                placeholder=" "
                @change="p=>{userDefinedRoleId2Handler(p)}"
              />
            </el-form-item>

          </div>
          <div class="section form-column">
            <el-form-item :label="$t('SeaExport.UserDefinedField1')">
              <el-input
                v-model="job.userDefinedField1"
                :disabled="readonly"
                no="userDefinedField1"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField1'),job.userDefinedField1,0,val=>{job.userDefinedField1=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField2')">
              <el-input
                v-model="job.userDefinedField2"
                :disabled="readonly"
                no="userDefinedField2"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField2'),job.userDefinedField2,0,val=>{job.userDefinedField2=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField3')">
              <el-input
                v-model="job.userDefinedField3"
                :disabled="readonly"
                no="userDefinedField3"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField3'),job.userDefinedField3,0,val=>{job.userDefinedField3=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.UserDefinedField4')">
              <el-input
                v-model="job.userDefinedField4"
                :disabled="readonly"
                no="userDefinedField4"
                type="textarea"
                :rows="5"
                @dblclick.native="showAdvanceTextDialog($t('SeaExport.UserDefinedField4'),job.userDefinedField4,0,val=>{job.userDefinedField4=val})"
              />
            </el-form-item>
            <el-form-item :label="$t('SeaExport.TaxNature')">
              <el-select
                v-model="job.taxNature"
                :disabled="readonly"
                no="taxNature"
                :placeholder="$t('SeaExport.PleaseSelect')"
                size="mini"
              >
                <el-option
                  v-for="(item,index) in TAX_NATURES"
                  :key="index"
                  :label="isZh?item.chineseName:item.englishName"
                  :value="item.code"
                />
              </el-select>&nbsp;
            </el-form-item>
          </div>
        </el-form>
      </div>

      <div class="section">
        <div class="form-row">
          <span class="title">{{ $t('SeaExport.TicketsInfo') }}</span>
          <div style="display: flex;justify-content: flex-start;margin-bottom: 5px;line-height: 28px">
            <span>{{ $t('SeaExport.TotalTickets') }}:</span>
            <span style="margin-right: 5px;">{{ job.lclSlaves ? job.lclSlaves.length : 0 }}</span>
            <div v-show="readonly&&viewSource==='bookingWorkspace'" class="triggers">
              <el-button no="NewTickets" type="primary" @click="addTicket_clickHandler">{{ $t('SeaExport.NewTickets') }}</el-button>
              <el-button no="EditTickets" type="primary" @click="editTicket_clickHandler">{{ $t('SeaExport.EditTickets') }}</el-button>
              <el-button no="AddTickets" type="primary" @click="queryAILclDialog.visible=true">{{ $t('SeaExport.AddTickets') }}</el-button>
              <el-button no="AddTickets" type="danger" @click="removeTicket_clickHandler">{{ $t('SeaExport.RemoveTickets') }}</el-button>
            </div>
          </div>
          <div style="min-height: 200px;flex-direction: column">
            <cargo-ag-grid
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="lclSlaves"
              style="height:300px;"
              @gridReady="params=>{gridApi=params.api}"
            />
            <div style="display: flex;justify-content: flex-end;">
              <div>{{ $t('SeaExport.TotalNumberOfPackages') }}：{{ lbTotal.lblTotalQuantity }}</div>
              <div style="margin-left: 10px;">{{ $t('SeaExport.TotalWeight2') }}：{{ lbTotal.lblTotalWeight }}</div>
              <div style="margin-left: 10px;">{{ $t('SeaExport.TotalCubage') }}：{{ lbTotal.lblTotalCubage }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 单号抄录 -->
    <import-prompt-title-dialog :visible.sync="importPromptTitleDialog.visible" :lob="job.lob" @selected="onExcerptionChangeFunc" />
    <!-- 代码检索 -->
    <import-bill-address-title-dialog :visible.sync="billAddressDialog.visible" :job="job" @callback="codeSearchCallback" />
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="665px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="readonly"
        :text-chars="advanceTextDialog.textChars"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :warning-count="-1"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="confirm" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button no="close" @click="advanceTextDialog.visible=false">{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 加入拼箱工作单查询弹窗 -->
    <query-ai-lcl-dialog :visible.sync="queryAILclDialog.visible" :job="job" @callback="slavedAddedHandler" />
  </div>
</template>

<script>
import tabBookingMasterJS from './tabBookingMaster.js'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoDepartmentSelect from '@/components/Cargo/Common/cargoDepartmentSelect'
import cargoDepartmentNewSelect from '@/components/Cargo/Common/cargoDepartmentNewSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import ImportPromptTitleDialog from '@/components/Cargo/Job/importPromptTitleDialog'
import ImportBillAddressTitleDialog from '@/components/Cargo/Job/importBillAddressTitleDialog'
import soNoInput from '@/components/Cargo/Job/soNoInput'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import queryAiLclDialog from '../queryAILclDialog'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import lang from '@/lang'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import { LOG_AI_AIR_BOOKING, RATE_TYPE, TAX_NATURES } from '@/class/cargo/model/parameters/SystemConstants'
import BasicTabMixin from '@/mixin/BasicTabMixin'
import { getBranchByLevel } from '@/utils/basicDataCache'
import { cache } from '@/utils/cacheManager'
import { handleBlur } from '@/utils/commonUtil'
import cargoProjectSelect from '@/components/Cargo/Common/cargoProjectSelect'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect.vue'

export default {
  name: 'AiTabBookingMaster',
  filters: {
    filterWeek(val) {
      switch (val) {
        case 'TUE': return lang.t('SeaExport.TUE')
        case 'WED': return lang.t('SeaExport.WED')
        case 'THU': return lang.t('SeaExport.THU')
        case 'FRI': return lang.t('SeaExport.FRI')
        case 'SAT': return lang.t('SeaExport.SAT')
        case 'SUN': return lang.t('Pricing.Sun')
        case 'MON':
        default: return lang.t('SeaExport.MON')
      }
    }
  },
  components: {
    cargoOfficeSelect,
    cargoAdvanceSelect, cargoPackingSelect, cargoDepartmentSelect, cargoDepartmentNewSelect, cargoInput, cargoRichTextarea, cargoUserSelect, cargoProjectSelect,
    ImportPromptTitleDialog, ImportBillAddressTitleDialog, soNoInput, queryAiLclDialog, AutoNumberInput
  },
  mixins: [BasicTabMixin],
  props: {
    context: { type: Object, required: true },
    action: { type: String, required: true },
    viewSource: { type: String, default: '' },
    cooperateEdit: { type: Boolean, default: true }, // 能否修改
    bookingAgentVisible: { type: Boolean, default: true },
    provisionPublished: { type: Boolean, default: false } // 计提已发布状态
  },
  data() {
    return {
      handleBlur,
      salesOfficeCheck: false,
      isWithinCloseAccountDate: false,
      TAX_NATURES,
      rateType: RATE_TYPE,
      job: new AirImportJob().fillDefaultValue().getData(),
      mblCode: '',
      mblNum: '',
      mblCodeNumValidate: true,
      txtSalesOffice: '', // 销售所在分公司
      valueMatch: {
        loadingPortCode: false,
        dischargingPortCode: false
      },
      lbTotal: {
        lblTotalWeight: 0,
        lblTotalCubage: 0,
        lblTotalQuantity: 0
      },
      importPromptTitleDialog: {
        visible: false
      },
      billAddressDialog: {
        visible: false
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        textChars: undefined,
        successCallback: null,
        isUppercase: true
      },
      queryAILclDialog: {
        visible: false
      },
      isAddUserDefinedRoles: false, // 是否显示自定义岗位
      JobUtils,
      overseaAgentUsersList: [], // 海外客服用户列表
      OverseaCustomerUtils,
      view: this,
      poNoRed: false,
      needConfirmProjectNo: false,
      location: LOG_AI_AIR_BOOKING.code,
      userPortRoleData: {
        userDefinedRole1: null,
        userDefinedRole2: null,
        userDefinedRole3: null,
        userDefinedRole4: null,
        overseaOp: null,
        siteOp: null,
        doc: null,
        csr: null,
        op: null,
        seaLine: null,
        airline: null,
        railwayLine: null
      },
      secondaryCustomJobTypeList: [],
      customJobTypeList: [],
      isZY: false, // 显示中邮选项
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      openProjectConfig: false,
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return this.action === 'look'
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look'
    },
    lclSlaves() {
      return this.job.lclSlaves || []
    },
    localCurrency() {
      return RateUtil.localCurrencyByOffice()
    },
    cacheOffices() {
      if (this.isRegionalCommission) {
        return getBranchByLevel(this.job.opOffice)
      } else {
        return null
      }
    },
    // 销售分公司
    salesOffice() {
      return this.job.salesOffice
    }
  },
  created() {
    this.isZY = String(cache.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
    this.notUppercaseShipperConsigneNotify = Number(cache.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isUppercaseByConfig = Number(cache.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.selectTypeNames = TYPE_NAMES
    this.ChargeUtils = ChargeUtils
    this.gridOptions = {}
    this.columnDefs = [
      {
        headerName: '', width: 55, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', width: 180 },
      { headerName: this.$t('SeaExport.Hbl2'), field: 'hbl', width: 180 },
      { headerName: this.$t('SeaExport.Shipper'), field: 'shipperCode', width: 180 },
      { headerName: this.$t('SeaExport.Consignee'), field: 'consigneeCode', width: 180 },
      { headerName: this.$t('SeaExport.PortOfDestination') + '(POD)', field: 'dischargingPortCode', width: 180 },
      { headerName: this.$t('SeaExport.PlaceOfDelivery'), field: 'destinationPlace', width: 180 },
      { headerName: this.$t('SeaExport.Quantity'), field: 'quantityContract', width: 180 },
      { headerName: this.$t('SeaExport.ChargedWeight'), field: 'chargeWeight', hide: true, width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.returnThreeZeroFormatNumber(params.value)
        }
      },
      {
        headerName: this.$t('SeaExport.GrossWeight'),
        field: 'weightContract',
        width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 3)
        }
      },
      {
        headerName: this.$t('SeaExport.Cubage'),
        field: 'cubageContract',
        width: 180,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 3)
        }
      }
    ]
    this.gridApi = null
  },
  methods: tabBookingMasterJS.methods
}
</script>

<style scoped lang="scss">
#app .section ::v-deep {
  .job-no-color.el-input {
    .el-input__inner {
      background: #99ff66 !important;
    }
  }
  .red {
    .el-input__inner {
      color: #f56c6c !important;
    }
  }
}
.poNoClass {
  /deep/ .el-input.is-disabled .el-input__inner {
    color: red !important;
  }
}
</style>
